module.exports = __webpack_public_path__ + "static/electrotransport-8c0a53a4713d930d3f99330721ebc782.webp";